import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useShop } from '@/state';
import { IconCart, IconHeart } from './icons';

const SHOP_NAME = (import.meta.env.VITE_SHOP_NAME as string | undefined) ?? 'ALKOR';

export function AppHeader() {
  const navigate = useNavigate();
  const { cartCount, favorites } = useShop();
  const [pulse, setPulse] = useState(false);
  const prev = useRef(cartCount);

  // Бейдж «подпрыгивает» только при росте — при удалении это выглядело бы странно
  useEffect(() => {
    if (cartCount > prev.current) {
      setPulse(true);
      const t = window.setTimeout(() => setPulse(false), 300);
      return () => window.clearTimeout(t);
    }
    prev.current = cartCount;
    return;
  }, [cartCount]);

  useEffect(() => { prev.current = cartCount; }, [cartCount]);

  return (
    <header className="app-head">
      <button type="button" className="app-head__logo" aria-label={`${SHOP_NAME} Tactical — на главную`} onClick={() => navigate('/')}>
        {/* Печать ALKOR TACTICAL — тот же знак, что в шапке сайта. */}
        <img
          className="app-head__seal"
          src="/brand/alkor-seal.png"
          onError={(e) => { e.currentTarget.src = '/brand/alkor-logo-transparent.png'; }}
          alt="" width={38} height={38}
        />
        <span className="app-head__lockup">
          <span className="app-head__wordmark">{SHOP_NAME}</span>
          <span className="app-head__tagline">Tactical</span>
        </span>
      </button>

      <button
        type="button"
        className={`headbtn${favorites.length ? ' headbtn--on' : ''}`}
        aria-label="Избранное"
        onClick={() => navigate('/favorites')}
      >
        <IconHeart filled={favorites.length > 0} />
        {favorites.length > 0 && <span className="badge">{favorites.length}</span>}
      </button>

      <button type="button" className="headbtn" aria-label="Корзина" onClick={() => navigate('/cart')}>
        <IconCart />
        {cartCount > 0 && <span className={`badge${pulse ? ' badge--pulse' : ''}`}>{cartCount}</span>}
      </button>
    </header>
  );
}
